module.exports = __webpack_public_path__ + "img/Case_1.27b3dd7c.jpg";